import { render, staticRenderFns } from "./autologout.vue?vue&type=template&id=5d58f345"
import script from "./autologout.vue?vue&type=script&lang=js"
export * from "./autologout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d58f345')) {
      api.createRecord('5d58f345', component.options)
    } else {
      api.reload('5d58f345', component.options)
    }
    module.hot.accept("./autologout.vue?vue&type=template&id=5d58f345", function () {
      api.rerender('5d58f345', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/auth/autologout.vue"
export default component.exports